export default "__VITE_ASSET__0b732c31__"